<script setup lang="ts">
defineProps<{
  icon?: string
}>()
</script>

<template>
  <div class="n-tip n-tip-base">
    <slot name="icon">
      <Icon v-if="icon" :name="icon" class="n-tip-icon" />
    </slot>
    <slot />
  </div>
</template>
